import axios from 'axios';
import { setupAuthInterceptor } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.configuration_api.monedas;

// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
}));

// Función para obtener todas las monedas desde la API
export const getAllMonedas = async () => {
  return await api.get('/GetAllMonedas');
};
